import AbstractAuthenticatedService from '@vertical-plus/vue-js-micro-service-components/lib/model/service/abstract-authenticated-service';
import CalendarJob from '@/model/entity/calendar/calendar-job';
import CalendarJobSearchConditionsInterface from '@/model/vo/calendar/calendar-job-search-conditions-interface';
import CalendarJobSearchResultsVo from '@/model/vo/calendar/calendar-job-search-results-vo';
import DeleteCalendarJobTask from '@/model/task/calendar/delete-calendar-job-task';
import GetCalendarJobTask from '@/model/task/calendar/get-calendar-job-task';
import GetCalendarJobsTask from '@/model/task/calendar/get-calendar-jobs-task';
import PatchCalendarJobTask from '@/model/task/calendar/patch-calendar-job-task';
import PostCalendarJobTask from '@/model/task/calendar/post-calendar-job-task';

export default class CalendarService extends AbstractAuthenticatedService
{
    /**
     * Returns matching calendar jobs
     *
     * @returns
     */

    public async findCalendarJobs(searchConditions?: CalendarJobSearchConditionsInterface): Promise<CalendarJobSearchResultsVo>
    {
        const task = new GetCalendarJobsTask();
        task.token = this.token;
        task.searchConditions = searchConditions;

        return this.runTask(task) as Promise<CalendarJobSearchResultsVo>;
    }

    /**
     * Loads a calendar job
     *
     * @param id
     * @returns
     */

    public async loadCalendarJob(id: string): Promise<CalendarJob>
    {
        const task = new GetCalendarJobTask();
        task.token = this.token;
        task.id = id;

        return this.runTask(task) as Promise<CalendarJob>;
    }

    /**
     * Creates a calendar job
     *
     * @param calendarJob
     * @returns
     */

    public async createCalendarJob(calendarJob: CalendarJob): Promise<CalendarJob>
    {
        const task = new PostCalendarJobTask();
        task.token = this.token;
        task.calendarJob = calendarJob;

        return this.runTask(task) as Promise<CalendarJob>;
    }

    /**
     * Updates a calendar job
     *
     * @param calendarJob
     * @returns
     */

    public async updateCalendarJob(calendarJob: CalendarJob): Promise<CalendarJob>
    {
        const task = new PatchCalendarJobTask();
        task.token = this.token;
        task.calendarJob = calendarJob;

        return this.runTask(task) as Promise<CalendarJob>;
    }

    /**
     * Deletes a calendar job
     *
     * @param calendarJob
     * @returns
     */

    public async deleteCalendarJob(calendarJobId: number): Promise<void>
    {
        const task = new DeleteCalendarJobTask();
        task.token = this.token;
        task.calendarJobId = calendarJobId;

        return this.runTask(task) as Promise<void>;
    }
}